export const DEFAULT_OPTIONS_COUNT = 5
export const DEFAULT_VALUE_KEY = 'value'
export const DEFAULT_TITLE_KEY = 'title'
export const MOBILE_WIDTH = '770px'
